import React from 'react';
import { styled, useMediaQuery } from '@mui/material';
import theme from '../../theme';
import { useLocation } from 'react-router-dom';
import { Colors } from 'library';
import { Link, Row } from 'library/ui';

const BrowserBar = styled('div')({
    position: 'fixed',
    height: 0,
    bottom: 23,
    right: 0,
});

const PublicFooter = () => {
    const pathname = useLocation().pathname;

    const wouldBeHiddenByMobileNav = useMediaQuery(theme.breakpoints.down('md'));
    const onMessagePage = pathname.includes('messages');

    return wouldBeHiddenByMobileNav || onMessagePage ? null : (
        <BrowserBar>
            <Row justify="end" fullWidth>
                <Link to="/" color={Colors.secondary} size="sm">
                    © {new Date().getFullYear()} Tandem, Inc.
                </Link>
            </Row>
        </BrowserBar>
    );
};

export default PublicFooter;
